import { render, staticRenderFns } from "./Power.vue?vue&type=template&id=9853c088&scoped=true"
import script from "./Power.vue?vue&type=script&lang=js"
export * from "./Power.vue?vue&type=script&lang=js"
import style0 from "./Power.vue?vue&type=style&index=0&id=9853c088&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9853c088",
  null
  
)

export default component.exports